import { lazyPage } from '@libs/templates/routing';
import { ErrorBoundary } from '@libs/templates/template-pages';
import { Route } from 'react-router';
import { AuthorizedContainer } from './layout';

export const systemManagementRouter = (
  <Route
    path="/system-management"
    element={<AuthorizedContainer />}
    errorElement={<ErrorBoundary isUnderSubsystem={false} />}
  >
    <Route index lazy={lazyPage(async () => import('./pages/MainMenu'))} />
    <Route path="/system-management/main-menu" lazy={lazyPage(async () => import('./pages/MainMenu'))} />
    <Route
      path="/system-management/api-key-mst/*"
      lazy={lazyPage(async () => import('./pages/ApiKeyIndex'))}
    />
    <Route
      path="/system-management/login-user-mst/*"
      lazy={lazyPage(async () => import('./pages/LoginUserIndex'))}
    />
    <Route path="/system-management/role-mst/*" lazy={lazyPage(async () => import('./pages/RoleIndex'))} />
    <Route
      path="/system-management/policy-mst/*"
      lazy={lazyPage(async () => import('./pages/PolicyIndex'))}
    />
    <Route path="/system-management/rule-mst/*" lazy={lazyPage(async () => import('./pages/RuleIndex'))} />
    <Route
      path="/system-management/company-info/*"
      lazy={lazyPage(async () => import('./pages/CompanyInfoIndex'))}
    />
    <Route
      path="/system-management/password-policy"
      lazy={lazyPage(async () => import('./pages/PasswordPolicySetting'))}
    />
    <Route path="/system-management/sso" lazy={lazyPage(async () => import('./pages/SsoSetting'))} />
    <Route
      path="/system-management/target-mst/*"
      lazy={lazyPage(async () => import('./pages/TargetIndex'))}
    />
    <Route
      path="/system-management/knowledge-base-mst/*"
      lazy={lazyPage(async () => import('./pages/KnowledgeBaseMstIndex'))}
    />
    <Route path="*" lazy={lazyPage(async () => import('@libs/templates/template-pages/NotFound'))} />
  </Route>
);
